import { initGTM } from './gtm';
import { EcommerceEvent, Item } from './ecommerce/tracking-ecommerce.events';
import { TrackingLegacyEvent } from './legacy/tracking-legacy.events';

type DataLayerContent = string | number | string[] | boolean | undefined | { items: Item[] };

declare global {
  const dataLayer: {
    [key in string]: DataLayerContent;
  }[];
}

export class TrackingService {
  public static initializeTracking(): void {
    initGTM();
  }

  public static trackEvent(event: TrackingLegacyEvent | EcommerceEvent): void {
    const payload = { ...event, _clear: true };
    dataLayer.push(payload);
  }
}
